export default "__VITE_ASSET__5C15$Vaz__"